import { useCallback, useState } from 'react';

export const useOnlineShopCard = () => {
  const [addModalState, setAddModalState] = useState<boolean>(false);
  const [isPasswordMode, setIsPasswordMode] = useState<boolean>(true);
  const [copyStatus, setCopyStatus] = useState<Record<string, boolean>>({});

  const onAddModalStateChange = useCallback(() => {
    setAddModalState((prevState) => !prevState);
  }, []);

  const onCopy = useCallback((value: string) => {
    navigator.clipboard.writeText(value).then(() => {
      setCopyStatus({ [value]: true });
    });
    setTimeout(() => {
      setCopyStatus({ [value]: false });
    }, 2000);
  }, []);
  const onPasswordModeChange = useCallback(() => setIsPasswordMode((oState) => !oState), []);
  return {
    addModalState,
    onAddModalStateChange,
    copyStatus,
    onCopy,
    isPasswordMode,
    onPasswordModeChange,
  };
};
